module.exports = __webpack_public_path__ + "static/media/vis.e82b54d1.webp";